<template>
  <div class="card card--white">
    <div class="card card--container">
      <h-input v-model="name" label='Name'/>
      <h-btn @click="save" class="small-top">Save</h-btn>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import snackbarHub from "@/services/hubs/snackbar";
const STORE_COHORT = "CoachCohort";

export default {
  data() {
    return {
      name: ""
    };
  },
  methods: {
    save() {
      dataStore.create(STORE_COHORT, { name: this.name }).then(r => {
        snackbarHub.update("Saved");
        this.$router.push("/cohorts/edit/" + r.id);
      });
    }
  }
};
</script>

<style>
</style>
